import { forEach, isElement } from 'lodash';

const
    moduleName = 'foldout',
    fadeafterbase = 8,
    selectors = {
        base: `.js-${moduleName}`,
        trigger: `.js-${moduleName}-trigger`,
        target: `.js-${moduleName}-target`,
        elements: `.js-${moduleName}-elements`,
        date: `.js-${moduleName}-date`
    };

export class Foldout {

    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this.baseElement = baseElement;
        this.elements = this.baseElement.querySelectorAll(selectors.elements);
        this.dates = this.baseElement.querySelectorAll(selectors.date);

        this.trigger = this.baseElement.querySelector(selectors.trigger);
        this.fadeafter = baseElement.getAttribute('data-fadecount');

        if (!this.fadeafter) this.fadeafter = fadeafterbase;
        if (this.elements.length > this.fadeafter) {
            this.trigger.parentElement.removeAttribute('hidden');
        }

        if(this.elements[this.fadeafter - 1]) {
            this.elements[this.fadeafter - 1].classList.add('last');
        }


        // Hide on pageload
        for (let i = 0; i <= this.elements.length; i++) {
            if (i >= this.fadeafter) {
                if (this.elements[i]) {
                    this.elements[i].setAttribute('hidden', true);
                    this.elements[i].setAttribute('toggle', true);

                    if (this.elements[i].previousElementSibling) {
                        if (this.elements[i].previousElementSibling.classList.contains('js-foldout-date')) {
                            this.elements[i].previousElementSibling.setAttribute('hidden', true);
                            this.elements[i].previousElementSibling.setAttribute('toggle', true);
                        }
                    }
                }
            }
        }

        this.trigger.addEventListener('click', (e) => this._handleTriggerClicked(e));


    }


    /* ================== EVENT HANDLING ===================== */


    _handleTriggerClicked(event) {
        event.preventDefault();
        if (this.trigger.hasAttribute('expanded')) {
            this.trigger.removeAttribute('expanded');

            forEach(this.elements, el => {
                if (el.hasAttribute('toggle')) {
                    el.setAttribute('hidden', true);
                }
            });

            forEach(this.dates, da => {
                if (da.hasAttribute('toggle')) {
                    da.setAttribute('hidden', true);
                }
            });

            // Scroll to right position;
            //this.elements[this.fadeafter].scrollIntoView();
            console.log(document.getElementsByClassName('last')[0])
            document.getElementsByClassName('last')[0].scrollIntoView({ behavior: "smooth" })



        }
        else {
            this.trigger.setAttribute('expanded', true)
            forEach(this.elements, el => {
                el.removeAttribute('hidden');
            });
            forEach(this.dates, da => {
                da.removeAttribute('hidden');
            });
        }

    }


    /* ================== EVENT HANDLING ===================== */

}

function init(baseElements = document.querySelectorAll(selectors.base)) {
    forEach(baseElements, baseElement => {
        new Foldout(baseElement);
    });
}
init();
